export { default } from "./AddOrRemoveStreamRuleText";
